export const selectCustomers = (state) => state.customers?.customers;
export const selectCustomer = (state) => state.customers?.customer;
